import React from "react";
import { SingleSelection } from "../../../../../components/GeneralSelection";
import { useTranslation } from "../../../../../hooks";
import { SelectChangeEvent } from "../../../../../components/MuiGenerals";
import { ChainSingleSelection } from "../../../../../components/ChainSelection";

interface IProps {
  value: string;
  onChange: (chainName: string) => void;
}

// currently will only support tron, not enable for selection
const ChainNameSingleSelection = (props: IProps) => {
  const { value, onChange } = props;

  const { t, translate } = useTranslation("tronWalletResourceBalance");

  return (
    <ChainSingleSelection
      label={t("phChainName")}
      setChoice={onChange}
      choice={value}
      disabled={true}
    />
  );
};

export default ChainNameSingleSelection;
